import React from 'react';
import { connect } from 'react-redux';
import { deleteImage } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';

const actions = {
  closeModal,
  deleteImage,
};

function ModalDeleteImage({ data, deleteImage, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const item = data.item;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteImage({ auth, history, values: item });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda yakin ingin menghapus file{' '}
        <span className='has-text-danger has-text-weight-semibold'>
          {item?.picture?.filename}
        </span>{' '}
        ?
      </p>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteImage);
